import ic5star from "./img/5star.min.svg";
import icBallBearing from "./img/ball-bearing.min.svg";
import icClean from "./img/clean.min.svg";
import icClean16 from "./img/clean-16.min.svg";
import icClean18 from "./img/clean-18.min.svg";
import icFan from "./img/fan.min.svg";
import icFire from "./img/fire.min.svg";
import icWind from "./img/wind.min.svg";
import icExtendable from "./img/extendable.min.svg";
import imgD16A from "./img/D16A.png";
import imgD18A from "./img/D18A.png";
import imgR16A from "./img/R16A.png";
import imgR19A from "./img/R18A.png";
import imgD12A from "./img/D12A.png";

export const COLORS = [
  {
    name: "black",
    color: "#606060",
    front: "black",
  },
  { name: "white", color: "#e7e7e7", front: "white" },
  { name: "blue", color: "#63c7fb", front: "black" },
  { name: "red", color: "#b62d35", front: "black" },
  { name: "brown", color: "#8b4513", front: "black" },
  { name: "pastel_blue", color: "#a9cee8", front: "white" },
  { name: "pastel_green", color: "#b5e3c7", front: "white" },
] as const;

export const models = [
  {
    image: imgD12A,
    name: "Mitsu D12A",
    short: "D12A",
    features: [
      {
        name: "New Design",
        label: "ดีไซน์ทันสมัย มีสไตล์ในทุกมิติ",
        icon: icFan,
      },
      {
        name: "Ball Bearing",
        label: "คงทนยาวนานกว่าเดิมด้วย\nมอเตอร์ Ball Bearing",
        icon: icBallBearing,
      },
      {
        name: "Engery Saving",
        label: "ฉลากประหยัดไฟฟ้า\nเบอร์ 5 ระดับ 5 ดาว",
        icon: ic5star,
      },
      {
        name: "Wider",
        label: "ส่งลมได้กว้างขึ้น และ ไกลขึ้น\nปริมาณลม 48 ลบ.ม./นาที",
        icon: icWind,
      },
      {
        name: "Easy to clean",
        label: "ง่าย และ สะดวกในการทำความสะอาด\nกับขนาดใบพัด 12 นิ้ว",
        icon: icClean,
      },
      {
        name: "Envirounmental",
        label: "วัสดุไม่ลุกลามไฟ และ\nเป็นมิตรต่อสิ่งแวดล้อม",
        icon: icFire,
      },
    ],
    variants: [COLORS[0], COLORS[1], COLORS[2], COLORS[3]],
    variations: {
      black: {
        full: require("./img/D12A/1016x2000-G-all.jpg"),
        side: require("./img/D12A/1602x1032-G-back.jpg"),
        front: require("./img/D12A/1602x1032-G-foot.jpg"),
      },
      blue: {
        full: require("./img/D12A/1016x2000-B-all.jpg"),
        side: require("./img/D12A/1602x1032-B-back.jpg"),
        front: require("./img/D12A/1602x1032-B-foot.jpg"),
      },
      red: {
        full: require("./img/D12A/1016x2000-R-all.jpg"),
        side: require("./img/D12A/1602x1032-R-back.jpg"),
        front: require("./img/D12A/1602x1032-R-foot.jpg"),
      },
      white: {
        full: require("./img/D12A/1016x2000-W-all.jpg"),
        side: require("./img/D12A/1602x1032-W-back.jpg"),
        front: require("./img/D12A/1602x1032-W-foot.jpg"),
      },
    } as Record<
      string,
      {
        full: string;
        side: string;
        front: string;
      }
    >,
  },
  {
    image: imgD16A,
    name: "Mitsu D16A",
    short: "D16A",
    features: [
      {
        name: "New Design",
        label: "ดีไซน์ทันสมัย มีสไตล์ในทุกมิติ",
        icon: icFan,
      },
      {
        name: "Ball Bearing",
        label: "คงทนยาวนานกว่าเดิมด้วย\nมอเตอร์ Ball Bearing",
        icon: icBallBearing,
      },
      {
        name: "Engery Saving",
        label: "ฉลากประหยัดไฟฟ้า\nเบอร์ 5 ระดับ 5 ดาว",
        icon: ic5star,
      },
      {
        name: "Wider",
        label: "ส่งลมได้กว้างขึ้น และ ไกลขึ้น\nปริมาณลม 87 ลบ.ม./นาที",
        icon: icWind,
      },
      {
        name: "Easy to clean",
        label: "ง่าย และ สะดวกในการทำความสะอาด\nกับขนาดใบพัด 16 นิ้ว",
        icon: icClean16,
      },
      {
        name: "Envirounmental",
        label: "วัสดุไม่ลุกลามไฟ และ\nเป็นมิตรต่อสิ่งแวดล้อม",
        icon: icFire,
      },
    ],
    variants: [COLORS[0], COLORS[1], COLORS[2], COLORS[3], COLORS[4]],
    variations: {
      black: {
        full: require("./img/D16A/1016x2000-G-all.jpg"),
        side: require("./img/D16A/1602x1032-G-back.jpg"),
        front: require("./img/D16A/1602x1032-G-foot.jpg"),
      },
      blue: {
        full: require("./img/D16A/1016x2000-B-all.jpg"),
        side: require("./img/D16A/1602x1032-B-back.jpg"),
        front: require("./img/D16A/1602x1032-B-foot.jpg"),
      },
      red: {
        full: require("./img/D16A/1016x2000-R-all.jpg"),
        side: require("./img/D16A/1602x1032-R-back.jpg"),
        front: require("./img/D16A/1602x1032-R-foot.jpg"),
      },
      white: {
        full: require("./img/D16A/1016x2000-W-all.jpg"),
        side: require("./img/D16A/1602x1032-W-back.jpg"),
        front: require("./img/D16A/1602x1032-W-foot.jpg"),
      },
      brown: {
        full: require("./img/D16A/1016x2000-Brown-all.jpg"),
        side: require("./img/D16A/1602x1032-Brown-back.jpg"),
        front: require("./img/D16A/1602x1032-Brown-foot.jpg"),
      },
    } as Record<
      string,
      {
        full: string;
        side: string;
        front: string;
      }
    >,
  },
  {
    image: imgD18A,
    name: "Mitsu D18A",
    short: "D18A",
    features: [
      {
        name: "New Design",
        label: "ดีไซน์ทันสมัยแบบทูโทน มีสไตล์ในทุกมิติ",
        icon: icFan,
      },
      {
        name: "Ball Bearing",
        label: "คงทนยาวนานกว่าเดิมด้วย\nมอเตอร์ Ball Bearing",
        icon: icBallBearing,
      },
      {
        name: "Engery Saving",
        label: "ฉลากประหยัดไฟฟ้า\nเบอร์ 5 ระดับ 5 ดาว",
        icon: ic5star,
      },
      {
        name: "Wider",
        label: "ส่งลมได้กว้างขึ้น และ ไกลขึ้น\nปริมาณลม 102 ลบ.ม./นาที",
        icon: icWind,
      },
      {
        name: "Easy to clean",
        label: "ง่าย และ สะดวกในการทำความสะอาด\nกับขนาดใบพัด 18 นิ้ว",
        icon: icClean18,
      },
      {
        name: "Envirounmental",
        label: "วัสดุไม่ลุกลามไฟ และ\nเป็นมิตรต่อสิ่งแวดล้อม",
        icon: icFire,
      },
    ],
    variants: [COLORS[0], COLORS[1], COLORS[2], COLORS[3], COLORS[4]],
    variations: {
      black: {
        full: require("./img/D18A/1016x2000-G-all.jpg"),
        side: require("./img/D18A/1602x1032-G-back.jpg"),
        front: require("./img/D18A/1602x1032-G-foot.jpg"),
      },
      blue: {
        full: require("./img/D18A/1016x2000-B-all.jpg"),
        side: require("./img/D18A/1602x1032-B-back.jpg"),
        front: require("./img/D18A/1602x1032-B-foot.jpg"),
      },
      red: {
        full: require("./img/D18A/1016x2000-R-all.jpg"),
        side: require("./img/D18A/1602x1032-R-back.jpg"),
        front: require("./img/D18A/1602x1032-R-foot.jpg"),
      },
      white: {
        full: require("./img/D18A/1016x2000-W-all.jpg"),
        side: require("./img/D18A/1602x1032-W-back.jpg"),
        front: require("./img/D18A/1602x1032-W-foot.jpg"),
      },
      brown: {
        full: require("./img/D18A/1016x2000-Brown-all.jpg"),
        side: require("./img/D18A/1602x1032-Brown-back.jpg"),
        front: require("./img/D18A/1602x1032-Brown-foot.jpg"),
      },
    } as Record<
      string,
      {
        full: string;
        side: string;
        front: string;
      }
    >,
  },
  {
    image: imgR16A,
    name: "Mitsu R16A",
    short: "R16A",
    features: [
      {
        name: "New Design",
        label: "ดีไซน์ทันสมัยแบบทูโทน\nพร้อมปรับระดับความสูงได้",
        icon: icExtendable,
      },
      {
        name: "Ball Bearing",
        label: "คงทนยาวนานกว่าเดิมด้วย\nมอเตอร์ Ball Bearing",
        icon: icBallBearing,
      },
      {
        name: "Engery Saving",
        label: "ฉลากประหยัดไฟฟ้า\nเบอร์ 5 ระดับ 5 ดาว",
        icon: ic5star,
      },
      {
        name: "Wider",
        label: "ส่งลมได้กว้างขึ้น และ ไกลขึ้น\nปริมาณลม 87 ลบ.ม./นาที",
        icon: icWind,
      },
      {
        name: "Easy to clean",
        label: "ง่าย และ สะดวกในการทำความสะอาด\nกับขนาดใบพัด 16 นิ้ว",
        icon: icClean16,
      },
      {
        name: "Envirounmental",
        label: "วัสดุไม่ลุกลามไฟ และ\nเป็นมิตรต่อสิ่งแวดล้อม",
        icon: icFire,
      },
    ],
    variants: [
      COLORS[0],
      COLORS[1],
      COLORS[2],
      COLORS[3],
      COLORS[5],
      COLORS[6],
    ],
    variations: {
      black: {
        full: require("./img/R16A/1016x2000-G-all.png"),
        side: require("./img/R16A/1602x1032-G-back.jpg"),
        front: require("./img/R16A/1602x1032-G-foot.jpg"),
      },
      blue: {
        full: require("./img/R16A/1016x2000-B-all.png"),
        side: require("./img/R16A/1602x1032-B-back.jpg"),
        front: require("./img/R16A/1602x1032-B-foot.jpg"),
      },
      red: {
        full: require("./img/R16A/1016x2000-R-all.png"),
        side: require("./img/R16A/1602x1032-R-back.jpg"),
        front: require("./img/R16A/1602x1032-R-foot.jpg"),
      },
      white: {
        full: require("./img/R16A/1016x2000-W-all.jpg"),
        side: require("./img/R16A/1602x1032-W-back.jpg"),
        front: require("./img/R16A/1602x1032-W-foot.jpg"),
      },
      pastel_blue: {
        full: require("./img/R16A/1016x2000-W-C-all.jpg"),
        side: require("./img/R16A/1602x1032-W-C-back.jpg"),
        front: require("./img/R16A/1602x1032-W-C-foot.jpg"),
      },
      pastel_green: {
        full: require("./img/R16A/1016x2000-W-G-all.jpg"),
        side: require("./img/R16A/1602x1032-W-G-back.jpg"),
        front: require("./img/R16A/1602x1032-W-G-foot.jpg"),
      },
    } as Record<
      string,
      {
        full: string;
        side: string;
        front: string;
      }
    >,
  },
  {
    image: imgR19A,
    name: "Mitsu R18A",
    short: "R18A",
    features: [
      {
        name: "New Design",
        label: "ดีไซน์ทันสมัยแบบทูโทน\nพร้อมปรับระดับความสูงได้",
        icon: icExtendable,
      },
      {
        name: "Ball Bearing",
        label: "คงทนยาวนานกว่าเดิมด้วย\nมอเตอร์ Ball Bearing",
        icon: icBallBearing,
      },
      {
        name: "Engery Saving",
        label: "ฉลากประหยัดไฟฟ้า\nเบอร์ 5 ระดับ 5 ดาว",
        icon: ic5star,
      },
      {
        name: "Wider",
        label: "ส่งลมได้กว้างขึ้น และ ไกลขึ้น\nปริมาณลม 102 ลบ.ม./นาที",
        icon: icWind,
      },
      {
        name: "Easy to clean",
        label: "ง่าย และ สะดวกในการทำความสะอาด\nกับขนาดใบพัด 18 นิ้ว",
        icon: icClean18,
      },
      {
        name: "Envirounmental",
        label: "วัสดุไม่ลุกลามไฟ และ\nเป็นมิตรต่อสิ่งแวดล้อม",
        icon: icFire,
      },
    ],
    variants: [
      COLORS[0],
      COLORS[1],
      COLORS[2],
      COLORS[3],
      COLORS[4],
      COLORS[5],
      COLORS[6],
    ],
    variations: {
      black: {
        full: require("./img/R18A/1016x2000-G-all.jpg"),
        side: require("./img/R18A/1602x1032-G-back.jpg"),
        front: require("./img/R18A/1602x1032-G-foot.jpg"),
      },
      blue: {
        full: require("./img/R18A/1016x2000-B-all.jpg"),
        side: require("./img/R18A/1602x1032-B-back.jpg"),
        front: require("./img/R18A/1602x1032-B-foot.jpg"),
      },
      red: {
        full: require("./img/R18A/1016x2000-R-all.jpg"),
        side: require("./img/R18A/1602x1032-R-back.jpg"),
        front: require("./img/R18A/1602x1032-R-foot.jpg"),
      },
      white: {
        full: require("./img/R18A/1016x2000-W-all.jpg"),
        side: require("./img/R18A/1602x1032-W-back.jpg"),
        front: require("./img/R18A/1602x1032-W-foot.jpg"),
      },
      brown: {
        full: require("./img/R18A/1016x2000-Brown-all.jpg"),
        side: require("./img/R18A/1602x1032-Brown-back.jpg"),
        front: require("./img/R18A/1602x1032-Brown-foot.jpg"),
      },
      pastel_blue: {
        full: require("./img/R18A/1016x2000-W-C-all.jpg"),
        side: require("./img/R18A/1602x1032-W-C-back.jpg"),
        front: require("./img/R18A/1602x1032-W-C-foot.jpg"),
      },
      pastel_green: {
        full: require("./img/R18A/1016x2000-W-G-all.jpg"),
        side: require("./img/R18A/1602x1032-W-G-back.jpg"),
        front: require("./img/R18A/1602x1032-W-G-foot.jpg"),
      },
    } as Record<
      string,
      {
        full: string;
        side: string;
        front: string;
      }
    >,
  },
];
